import React from 'react';
import {
  Arrow,
  ArrowContainer,
  Button,
  Container,
  QuantityBadge,
  QuantityWrapper,
  TextWrapper,
} from './styles/filterButton';
import { FilterButtonProps } from './types';

export const FilterButton: React.FC<FilterButtonProps> = (props) => {
  const {
    children,
    isActive,
    isDockedOnDesktop = false,
    onClick,
    order = 1,
    show = true,
    showArrow = true,
    quantity,
    hasSelection,
  } = props;

  return (
    <Button
      onClick={onClick}
      isActive={isActive}
      order={order}
      show={show}
      isDockedOnDesktop={isDockedOnDesktop}
      hasSelection={hasSelection}>
      <Container>
        <TextWrapper>{children}</TextWrapper>
        {!!quantity && (
          <QuantityBadge>
            <QuantityWrapper>{quantity}</QuantityWrapper>
          </QuantityBadge>
        )}
        {showArrow && (
          <ArrowContainer isActive={isActive}>
            <Arrow />
          </ArrowContainer>
        )}
      </Container>
    </Button>
  );
};
